import React, { useEffect, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router";
import Header from "./Header";
import Footer from "../Footer";
import fire from "./Firebase";
import "../App.css";
function CertificateTemp5() {
  document.title = "HR School-Template 5";
  const [temp4, settemp4] = useState({});
  const conponentPDF = useRef();
  useEffect(() => {
    fire.child("certificates").on("value", (data) => {
      if (data.val() == null || data.val() == "") alert("Data Fetch");
      else {
        settemp4(data.val());
      }
      console.log(data.val());
    });
  }, []);
  const navigate = useNavigate();
  function generatePDF(keys) {
    sessionStorage.setItem("lastname5", keys);
    navigate("/try5");
  }
  return (
    <div>
      <Header />
      <center>
        {" "}
        <h1>Download PDF Certificate</h1>
      </center>
      <div id="maindiv" ref={conponentPDF}>
        {Object.keys(temp4).map((all, index) => {
          return (
            <>
              <div id="certificatetemp5" style={{textTransform:"uppercase"}}>
                <center style={{ padding: "60px" }}>
                  {" "}
                  <br />
                  <br />
                  <h1>HR SCHOOL</h1>
                  <hr />
                  <h3>CERTIFICATE OF COMPLETION</h3>
                  <br />
                  <h2> CERTIFIED {temp4[all].Field} SPECIALIST</h2>
                  <br />
                  <p>THIS IS TO CERTIFY THAT</p>
                  <p className="temp5name">NAME :- {temp4[all].Gender} {temp4[all].Name}</p>
                  <p className="temp5name">
                    FATHER NAME :- {temp4[all].Father}
                  </p>
                  <p className="temp5name">
                    COURSE DURATION :- {temp4[all].Course} MONTHS
                  </p>
                  <p className="temp5name">
                    COURSE NAME :- {temp4[all].Coursename}
                  </p>
                  <div>
                    <div style={{ fontWeight: "bold" }}>
                      WITH SCORE OF {temp4[all].grade}
                    </div>{" "}
                    <br />
                    <div style={{ fontWeight: "bold" }}>Dated</div> <br />
                    <br />
                  </div>
                  <div>START DATE :- {temp4[all].startdate}/{temp4[all].startmonth}/{temp4[all].startyear}</div>
                  <br />
                  <div>END DATE :-{temp4[all].enddate}/{temp4[all].endmonth}/{temp4[all].endyear}</div> <br />
                  <div>www.hrschool.com</div>
                </center>
              </div>
              <center>
                {" "}
                <br />
                <button onClick={() => generatePDF(all)}> Download {temp4[all].Name} Image</button>
              </center>
            </>
          );
        })}
      </div>

      <Footer />
    </div>
  );
}

export default CertificateTemp5;
